import { render } from "./GraphInfo.vue?vue&type=template&id=2b18cc5b&scoped=true"
import script from "./GraphInfo.vue?vue&type=script&lang=js"
export * from "./GraphInfo.vue?vue&type=script&lang=js"

import "./GraphInfo.vue?vue&type=style&index=0&id=2b18cc5b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2b18cc5b"

export default script